module.exports = __webpack_public_path__ + "static/media/Acc-1a.f91a275b.png";